import { render, staticRenderFns } from "./verificationLogin.vue?vue&type=template&id=f5a1b27a"
import script from "./verificationLogin.vue?vue&type=script&lang=js"
export * from "./verificationLogin.vue?vue&type=script&lang=js"
import style0 from "./verificationLogin.vue?vue&type=style&index=0&id=f5a1b27a&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports